<div class="health-insurance-add-dialog">
  <button *ngIf="openDialogButton"
          class="si-button_link-thick"
          type="button"
          translate="SI_INSURANCE_ADD"
          [disabled]="openDialogButtonDisabled"
          (click)="onClickButtonAddInsurance()"
  ></button>
  <ng-container *ngIf="displayDialog">
    <si-generic-dialog [(displayDialog)]="displayDialog"
                       dialogTitle="SI_INSURANCE_ADD"
                       dialogTitleStyleClass="mb-3"
                       button1Text="CORE_ADD"
                       button1Class="si-button_main"
                       [button1Disabled]="healthInsuranceAddForm?.invalid"
                       button2Text="SI_CANCEL"
                       button2Class="si-button_secondary"
                       (updateButton1Change)="onClickAddInsurance()">
      <div>
        <form #healthInsuranceAddForm="ngForm"
              id="healthInsuranceAddForm"
              name="healthInsuranceAddForm">
          <div class="row pasi-gap-v-12">
            <div class="col-12">
              <si-selector id="healthInsuranceCollective"
                           name="healthInsuranceCollective"
                           text="SI_INSURANCE"
                           placeholder="SI_SELECT_PLACEHOLDER"
                           [(model)]="model.collective"
                           path="/api/v1/insurance?allInsurances=true&isPrivate=false"
                           [showClear]="false"
                           rule="generic.fieldNotNull">
              </si-selector>
            </div>
            <div class="col-12">
              <si-input id="healthInsuranceAddPolicy"
                        name="healthInsuranceAddPolicy"
                        text="SI_POLICY_NUMBER"
                        placeholder="SI_WRITE_HERE"
                        [(model)]="model.policyNumber"
                        rule="generic.alphanumericLength50"
              ></si-input>
            </div>
            <div class="col-12">
              <si-input id="healthInsuranceAddCard"
                        name="healthInsuranceAddCard"
                        text="SI_CARD_NUMBER"
                        placeholder="SI_WRITE_HERE"
                        [(model)]="model.cardNumber"
                        rule="generic.alphanumericLength50"
              ></si-input>
            </div>
          </div>
        </form>
      </div>
    </si-generic-dialog>
  </ng-container>
  <ng-container *ngIf="displayErrorDialog">
    <si-generic-dialog [(displayDialog)]="displayErrorDialog"
                       dialogTitle="SI_ATTENTION"
                       dialogTitleStyleClass="mb-3"
                       dialogText="SI_INSURANCE_ALREADY_ADDED"
                       button1Text="SI_ACCEPT"
                       button1Class="si-button_main">
    </si-generic-dialog>
  </ng-container>
</div>
